/**
 * Constantes liées aux commissions
 */

/**
 * Taux de commission par défaut pour toutes les nouvelles organisations
 * Ce taux est appliqué lors de la création d'une organisation (en pourcentage)
 */
export const DEFAULT_COMMISSION_RATE = 2.8;

/**
 * Commission fixe CashLive par défaut (en centimes)
 * Freemium : aucun forfait CashLive (0). Les frais Stripe (1.5% + 0,25€)
 * sont ajoutés séparément uniquement en mode Stripe Connect.
 */
export const DEFAULT_FIXED_COMMISSION = 0;

/**
 * Configuration par défaut des commissions
 */
export const DEFAULT_COMMISSION_CONFIG = {
  commissionRate: DEFAULT_COMMISSION_RATE,
  fixedCommission: DEFAULT_FIXED_COMMISSION,
} as const;
